import React, { useMemo } from "react";
import { IoHeart } from "react-icons/io5";
import Main from "../../components/layout/Main";
import DeviceCard, { CardSkeletons } from "../../components/device/DeviceCard";
import usePropertyDevices from "../../hooks/usePropertyDevices";
import { User } from "../../storage/store";

// All favourite devices (app/screens/FavouriteDevices.js). A device is added or
// removed with the heart on its details page.
function Favourites() {
  const { devices, error } = usePropertyDevices();

  const favourites = useMemo(() => {
    if (!devices) return null;
    const username = User.getUser();
    return devices.filter((device) => device.usersFavourite?.includes(username));
  }, [devices]);

  return (
    <Main header="stack" title="Favourites">
      {error ? (
        <div className="hx-empty" role="alert">
          Couldn't load your favourites. Check your connection and reload the page.
        </div>
      ) : (
        <div className="hx-grid" style={{ paddingTop: 10 }}>
          {favourites === null ? (
            <CardSkeletons count={6} />
          ) : favourites.length ? (
            favourites.map((device) => <DeviceCard key={device.applianceId ?? device.deviceId} device={device} />)
          ) : (
            <div className="hx-empty-page" style={{ gridColumn: "1 / -1" }}>
              <IoHeart aria-hidden="true" />
              <p>No favourites yet</p>
              <span>Open a device and tap the heart to add it here.</span>
            </div>
          )}
        </div>
      )}
    </Main>
  );
}

export default Favourites;
